// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__CDMEt","insightsList":"newBusinessInsightsMenu_insightsList__2Bst5","active":"newBusinessInsightsMenu_active__Xp3xj"};